
import { size } from 'lodash';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { emitter } from '../../../utils/emitter';
import _ from 'lodash'; // thu vien giup cac hang viet ngan gon hon
class ModalEditClient extends Component {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            fullname: '',
            address: '',
            roleid: '',
            region: '',
        }

    }

    componentDidMount() {
        // console.log('Did mount edit Client: ', this.props.currentClient)
        let Client = this.props.currentClient;
        if (Client && !_.isEmpty(Client)) {
            this.setState({
                email: Client.email,
                password: "Hcode",
                fullname: Client.fullname,
                address: Client.address,
                id: Client.id
            })
        }
    }
    toggle = () => {
        this.props.tooglefromParent()
    }
    handleOnchangeInput = (event, id) => {
        // bad code this.state[id] = event.target.value , ko nen update truc tiep
        // good code, thong qua 1 bien trung gian
        let copyState = { ...this.state }; // copy state moi
        copyState[id] = event.target.value
        this.setState({
            ...copyState
        }, () => { // callback function

        })
        // console.log("copyState: ", copyState)
        // console.log(event.target.value, id)
    }
    checkValideInput = () => {
        let arrInput = ['fullname', 'address'];
        let isValide = true;
        for (let i = 0; i < arrInput.length; i++) { // neu dung vong lap MAP thi ko the dung break, foreach

            if (!this.state[arrInput[i]]) {
                isValide = false
                alert("Missing parameters" + arrInput[i]);
                break;
            }
        }
        return isValide
    }
    handleEditClient = () => {
        let isValide = this.checkValideInput();
        if (isValide == true) {
            this.props.editCurrentClient(this.state)
        }


        // console.log("data modal edit Client: ", this.state)
    }

    render() {
        // console.log('check child props:', this.props);
        // console.log('check child open modal:', this.props.currentClient);
        return (
            <Modal
                isOpen={this.props.isOpen}
                toggle={this.toggle}
                className="modal-Client-container"
                size="lg"
                centered
            >
                <ModalHeader toggle={this.toggle}>Edit Client</ModalHeader>
                <ModalBody>
                    <div className='modal-Client-body'>

                        <div className='input-container'>
                            <label>Email: </label>
                            <input
                                type="email"
                                name="email"
                                placeholder="Enter email"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'email')
                                }}
                                value={this.state.email}
                                disabled
                            />
                        </div>
                        <div className='input-container'>
                            <label>Password: </label>
                            <input
                                type="password"
                                name="password"
                                placeholder="Enter password"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'password')
                                }}
                                value={this.state.password}
                                disabled
                            />
                        </div>
                    </div>
                    <div className='modal-Client-body'>
                        <div className='input-container'>
                            <label>Fullname: </label>
                            <input
                                type="fullname"
                                name="fullname"
                                placeholder="Enter fullname"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'fullname')
                                }}
                                value={this.state.fullname}
                            />
                        </div>
                        <div className='input-container'>
                            <label>Address: </label>
                            <input
                                type="address"
                                name="address"
                                placeholder="Enter address"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'address')
                                }}
                                value={this.state.address}
                            />
                        </div>
                    </div>
                    <div className='modal-Client-body'>
                        <div className='input-container'>
                            <label>Role: </label>
                            <input
                                type="roleid"
                                name="roleid"
                                placeholder="Enter role"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'roleid')
                                }}
                            />
                        </div>

                    </div>
                    <div className='modal-Client-body'>
                        <div className='input-container max-width-input'>
                            <label>Region: </label>
                            <input
                                type="region"
                                name="region"
                                placeholder="Enter region"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'region')
                                }}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button className='px-2' color="primary" onClick={this.handleEditClient}>Save</Button>{' '}
                    <Button className='px-2' color="secondary" onClick={this.toggle}>Close</Button>
                </ModalFooter>
            </Modal>
        )
    }

}

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalEditClient);


